import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { LOCATION_ON_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const LocationOnRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={LOCATION_ON_ROUNDED_GLYPH} />;
